import styled from 'styled-components';

export const CommentSectionWrapper = styled.div`
.text-align-left{
    text-align: left;
}
.site-content {
    width: 90%;
    margin: auto;
    padding: 5px;
}
.comments{
    padding: 10px;
    background-color: #f9f9f9;
}
`;
